const initialState = {
    filterCriteria : {},
    deviceList : [],
    size : 0,
    start : 0,
    end : 10,
    pageNumber : 1,
    sortOrder : null,
    sortColumn : null,
    deviceTypes : [],
    deciveGroups : [],
    nextToken : null,
    deviceCount : 0,
    deviceDetails:[],
    error:null
}

export default function reducer(state = initialState, action) {
    switch(action.type) {
        case 'FETCH_DEVICE_SUCCESS' : {
            const deviceDetailArray = action.payload.data.data.data[0];
            const devices = state.deviceList.concat(deviceDetailArray.devices);
            return { 
                ...state,
                deviceList : devices, 
                deviceDetails : deviceDetailArray, 
                size : devices.length,
                deviceCount : deviceDetailArray.devices_count, 
                filterCriteria : { 
                    "device_attributes" :deviceDetailArray.device_attributes, 
                    "filter_name" : deviceDetailArray.filter_name, 
                    "device_names_included_pattern" : deviceDetailArray.device_names_included_pattern, 
                    "device_types" : deviceDetailArray.device_types, 
                    "device_software_version" : deviceDetailArray.device_software_version, 
                    "device_groups" : deviceDetailArray.device_groups,
                    "device_connectivity_attributes" : deviceDetailArray.device_connectivity_attributes
                },
                nextToken : deviceDetailArray.next_token,
                start : action.payload.start,
                end : action.payload.end,
                pageNumber : action.payload.pageNumber,
            }
        }
        case "FETCH_DEVICE_REJECTED": {
            return {...state, error: action.payload}
        }
        case 'CLEAR_DEVICE_MANAGEMENT' : {
            return {
                ...state,
                filterCriteria : {},
                deviceList : [],
                size : 0,
                start : 0,
                end : 10,
                pageNumber : 1,
                sortOrder : null,
                sortColumn : null,
                deviceTypes : [],
                deciveGroups : [],
                nextToken : null,
                deviceCount : 0,
                deviceDetails:[]
            }
        }
        case 'LOAD_NEXT_PAGE' : {
            return {
                ...state,
                start : action.payload.start,
                end : action.payload.end,
                pageNumber : action.payload.pageNumber,
                message : null
            }
        }
    }
    return state
}